import { faPlus, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import React, { Component } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import HiddenInput from '../../collection/inputs/HiddenInput';
import { triggerOnEnter } from '../../utils/functions';
import { notify } from '../../utils/notifications';

/**
 * Input complejo que consiste en un listado de fechas variable.
 * Props:
 * - name: Input name.
 * - fechas: Listado de fechas por defecto.
 */
export default class ListadoFechas extends Component {

    constructor(props) {
        super(props);
        let fechas = [];
        if (props.fechas) {
            props.fechas.map((fecha) => {
                fechas.push(moment(fecha));
            });
        }
        this.state = {
            fechas: fechas,
            fechaForm: ""
        };

        this.handleDelete = this.handleDelete.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
        this.handleChange = this.handleChange.bind(this);
            }

    componentDidMount() {
        this.onChange(this.state.fechas);
    }

    handleDelete(e) {
        let fechas = this.state.fechas;
        const index = e.target.closest("[index]").getAttribute("index");
        fechas.splice(index, 1);
        this.onChange(fechas);
    }

    handleAdd(e) {
        let fechas = this.state.fechas;
        let fecha = moment(this.state.fechaForm, "DD/MM/YY");
        if (fecha.isValid()) {
            if (!this.estaFecha(fecha)) {
                fechas.push(fecha);
                this.onChange(fechas);
                e.target.closest("#groupfecha").querySelector("#inputfecha").value = "";
            } else {
                notify("La fecha ya existe", "warning");
            }
        } else {
            notify("Fecha no válida", "warning");
        }
    }

    handleChange(e) {
        const value = e.target.value;
        this.setState({ fechaForm: value });
    }

    onChange(fechas) {
        fechas = fechas.sort((a, b) => a.valueOf() - b.valueOf());
        this.setState({ fechas: fechas });
        const value = this.getValue(fechas);
        if (typeof this.props.onChange === 'function') {
            this.props.onChange(value);
        }
    }

    getValue(fechas) {
        let value = [];
        fechas.map((fecha) => {
            value.push(fecha.format("YYYY-MM-DD"));
        });
    }

    estaFecha(fecha) {
        for (let i = 0; i < this.state.fechas.length; i++) {
            const f = this.state.fechas[i];
            if (f.isSame(fecha)) {
                return true;
            }
        }
        return false;
    }

    render() {
        const fechas = this.state.fechas.map((fecha, index) => {
            return (
                <div key={index} index={index} className="d-flex justify-content-between">
                    <HiddenInput name={this.props.name} value={fecha.format("YYYY-MM-DD")} />
                    {fecha.format("DD/MM/YYYY")}
                    <FontAwesomeIcon icon={faTimes} title="Eliminar" className="text-danger" role="button" onClick={this.handleDelete} />
                </div>
            );
        });
        return (
            <div className={this.props.className}>
                <span>{this.props.label}</span>
                <div className="p-2">
                    {fechas}
                </div>
                <InputGroup id="groupfecha" triggeronenterparent="true" onKeyPress={triggerOnEnter}>
                    <Form.Control
                        placeholder="Añadir festivo"
                        id="inputfecha"
                        onChange={this.handleChange}
                    />
                    <Button
                        onClick={this.handleAdd}
                        variant="success"
                        triggeronenter="true">
                        <FontAwesomeIcon icon={faPlus} />
                    </Button>
                </InputGroup>
            </div>
        );
    }
}
